//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name: 'HarveyBradshawIndex',
  data () {
    return {
      form: {
        healthcondition: '',
        stomachache: '',
        waterystool: '',
        abdominalmass: '',
        jointpain: '0',
        uveitis: '0',
        ENL: '0',
        Aphitulcer: '0',
        pyoderma: '0',
        analfissure: '0',
        Neonatalfistula: '0',
        abscess: '0'
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', name: '良好'},
        {value: '1', name: '稍差'},
        {value: '2', name: '差'},
        {value: '3', name: '不良'},
        {value: '4', name: '极差'}
      ],
      dataList2: [
        {value: '0', name: '无'},
        {value: '1', name: '轻度'},
        {value: '2', name: '中度'},
        {value: '3', name: '重度'}
      ],
      dataList3: [
        {value: '0', name: '无'},
        {value: '1', name: '可疑'},
        {value: '2', name: '确定'},
        {value: '3', name: '明确并腹痛'}
      ],
      dataList4: [
        {value: '0', name: '否'},
        {value: '1', name: '是'}
      ],
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        let result = form.healthcondition + form.stomachache + form.waterystool + form.abdominalmass + form.jointpain + form.uveitis + form.ENL + form.Aphitulcer + form.pyoderma + form.analfissure + form.Neonatalfistula + form.abscess
        if (result < 5) {
          self.descTxt = '临床缓解期 '
        } else if (result > 4 && result < 8) {
          self.descTxt = '轻度活动期'
        } else if (result > 7 && result < 17) {
          self.descTxt = '中度活动期 '
        } else if (result > 16) {
          self.descTxt = '重度活动期'
        }
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/HarveyBradshawIndex.vue